import { AppShell } from '@mantine/core';
import { createAddJackpotModal } from 'features/add-jackpot';
import { createBlockJackpotModal } from 'features/block-jackpot';
import { createDeleteJackpotModal } from 'features/delete-jackpot';
import { createEditJackpotModal } from 'features/edit-jackpot';
import { createUnblockJackpotModal } from 'features/unblock-jackpot';
import { createJackpotRegistry } from 'entities/jackpot';
import { jackpotsPageModel } from '../../model';
import cls from './jackpots-page.module.scss';

const JackpotRegistry = createJackpotRegistry(jackpotsPageModel.jackpotRegistryModel);

const DeleteJackpotModal = createDeleteJackpotModal(jackpotsPageModel.deleteJackpotModel);
const AddJackpotModal = createAddJackpotModal(jackpotsPageModel.addJackpotModel);

const EditJackpotModal = createEditJackpotModal(jackpotsPageModel.editJackpotModel);

const BlockJackpotModal = createBlockJackpotModal(jackpotsPageModel.blockJackpotModel);

const UnblockJackpotModal = createUnblockJackpotModal(jackpotsPageModel.unblockJackpotModel);

export const JackpotsPage = () => (
	<>
		<AppShell.Main className={cls.jackpotsPage}>
			<JackpotRegistry
				emptyActionSlot={<AddJackpotModal.Button />}
				topBarActionSlot={<AddJackpotModal.Button />}
				tableTdActionSlot={(jackpot) => (
					<div className={cls.jackpotsPageActions}>
						<EditJackpotModal.ActionIcon modalData={jackpot} />
						{jackpot.isLocked ? (
							<UnblockJackpotModal.ActionIcon modalData={jackpot} />
						) : (
							<BlockJackpotModal.ActionIcon modalData={jackpot} />
						)}
						<DeleteJackpotModal.ActionIcon modalData={jackpot} />
					</div>
				)}
			/>
		</AppShell.Main>
		<DeleteJackpotModal />
		<AddJackpotModal />
		<EditJackpotModal />
		<BlockJackpotModal />
		<UnblockJackpotModal />
	</>
);
